// extracted by mini-css-extract-plugin
export default {"wrapper":"PagePgr_wrapper__M0Je0"};